import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookHumsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          hums: [],
          st: '',
          flight_report_leg_id: '',
          absence: false,
          red: false,
          yellow: false,
          failure: false,
          not_read: false,
          not_installed: false,
          na: false,
          confirmed_na: false,
          confirmed_unknown: false,
          confirmed_false: false,
          confirmed_real: false,
          hum_status: '',
          hums_confirmed: '',
          hums_approval_date: '',
          hums_approval_user_id: '',
          hums_user_name: '',
          hums_justification: '',
          hums_justification_input: '',
          modal_justification: false,
          pending_status_choice: null,
        };
        this.handleNaJustificationChange = this.handleNaJustificationChange.bind(this);
        this.closeJustificationModal = this.closeJustificationModal.bind(this);
        this.confirmNaJustification = this.confirmNaJustification.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleCheckboxChange(name, event) {
        if (name === 'na') {
          if (!event || event.target.checked === true) {
            this.setState({
              modal_justification: true,
              pending_status_choice: 'na',
              hums_justification_input: this.state.hums_justification || '',
            });
          }
          return;
        }

        var change = {};
        if (this.state.hums_status && typeof this.state[this.state.hums_status] !== 'undefined') {
          change[this.state.hums_status] = false;
        }

        if (event == null || (event && event.target.checked === true)) {
          change[name] = true;
          change['hums_status'] = name;
          change['na'] = false;
          change['hums_justification'] = '';
          change['hums_justification_input'] = '';
          change['pending_status_choice'] = null;
          this.setState(change);
          this.props.editHums(this.state.flight_report_leg_id, name, this.state.hums_confirmed, null);
        }
      }
      
      handleCheckboxChangeConfirmed(name, event) {
        // valor selecionado. Valor são true e false
        var value = event.target.checked;
        var change = {};
        if(event == null) {
          change[name] = true;
        } else {
          change[this.state.hums_confirmed] = false;
          change[name] = true;
          change['hums_confirmed'] = name;
        }
        this.setState(change);
        this.props.editHums(this.state.flight_report_leg_id, this.state.hums_status, name, this.state.hums_justification);
      }

      handleNaJustificationChange(event) {
        this.setState({ hums_justification_input: event.target.value });
      }

      closeJustificationModal() {
        this.setState({
          modal_justification: false,
          pending_status_choice: null,
          hums_justification_input: '',
        });
      }

      confirmNaJustification() {
        const justification = (this.state.hums_justification_input || '').trim();
        if (!justification) {
          if (typeof this.props.handleAlert === 'function') {
            this.props.handleAlert('Justificativa obrigatória para marcar HUMS como N/A.', 'error', 'open');
          }
          return;
        }

        var change = {};
        if (this.state.hums_status && this.state.hums_status !== 'na' && typeof this.state[this.state.hums_status] !== 'undefined') {
          change[this.state.hums_status] = false;
        }

        change['na'] = true;
        change['hums_status'] = 'na';
        change['hums_justification'] = justification;
        change['modal_justification'] = false;
        change['pending_status_choice'] = null;
        change['hums_justification_input'] = '';

        this.setState(change, () => {
          this.props.editHums(this.state.flight_report_leg_id, 'na', this.state.hums_confirmed, justification);
        });
      }
    
      // LM
      componentWillReceiveProps(newProps) {
        if(typeof newProps.hums !== 'undefined' && newProps.hums !== null && this.state.loaded === 0) {
          var change = {};
          if (newProps.hums.hums_status) {
            change[newProps.hums.hums_status] = true;
            if (newProps.hums.hums_status !== 'na') {
              change['na'] = false;
            }
          }
          if (newProps.hums.hums_confirmed) {
            change[newProps.hums.hums_confirmed] = true;
          }
          this.setState(change);
          this.setState({
            loaded: 1,
            hums: newProps.hums,
            st: newProps.hums.st,
            flight_report_leg_id: newProps.hums.flight_report_leg_id,
            hums_status: newProps.hums.hums_status,
            hums_confirmed: newProps.hums.hums_confirmed,
            hums_approval_date: newProps.hums.hums_approval_date,
            hums_approval_user_id: newProps.hums.hums_approval_user_id,
            hums_user_name: newProps.hums.hums_user_name,
            hums_justification: newProps.hums.hums_justification || '',
            na: newProps.hums.hums_status === 'na',
          });
        }
      }
    
      render() {
        var self = this;
        return (
          <tr className="text-center" key={this.state.flight_report_leg_id}>
            <td>
              <input type="text" name="st" className="form-control text-center" value={this.state.st} disabled />
            </td>
            <td>
              <div className='row'>
                <div className='col-md-3'>
                  <div className="form-group">
                    <label>
                      <input
                        name="absence"
                        type="checkbox"
                        checked={this.state.absence}
                        onChange={this.handleCheckboxChange.bind(this, 'absence')} 
                      />
                      &nbsp;
                      Absence
                    </label>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className="form-group">
                    <label>
                      <input
                        name="red"
                        type="checkbox"
                        checked={this.state.red}
                        onChange={this.handleCheckboxChange.bind(this, 'red')} 
                      />
                      &nbsp;
                      Red
                    </label>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className="form-group">
                    <label>
                      <input
                        name="yellow"
                        type="checkbox"
                        checked={this.state.yellow}
                        onChange={this.handleCheckboxChange.bind(this, 'yellow')} 
                      />
                      &nbsp;
                      Yellow
                    </label>
                  </div>
                </div>
                <div className='col-md-3'>
                  <div className="form-group">
                    <label>
                      <input
                        name="na"
                        type="checkbox"
                        checked={this.state.na}
                        onChange={this.handleCheckboxChange.bind(this, 'na')} 
                      />
                      &nbsp;
                      N/A
                    </label>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label>
                      <input
                        name="failure"
                        type="checkbox"
                        checked={this.state.failure}
                        onChange={this.handleCheckboxChange.bind(this, 'failure')} 
                      />
                      &nbsp;
                      Failure
                    </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label>
                      <input
                        name="not_read"
                        type="checkbox"
                        checked={this.state.not_read}
                        onChange={this.handleCheckboxChange.bind(this, 'not_read')} 
                      />
                      &nbsp;
                      Not Read
                    </label>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="form-group">
                    <label>
                      <input
                        name="not_installed"
                        type="checkbox"
                        checked={this.state.not_installed}
                        onChange={this.handleCheckboxChange.bind(this, 'not_installed')} 
                      />
                      &nbsp;
                      Not Installed
                    </label>
                  </div>
                </div>
              </div>
              {this.state.hums_status === 'na' && this.state.hums_justification ? (
                <div className='row'>
                  <div className='col-md-12 text-left'>
                    <small><strong>Justificativa:</strong> {this.state.hums_justification}</small>
                  </div>
                </div>
              ) : null}
              <Modal show={this.state.modal_justification} aria-labelledby="hums-na-justification-modal" bsSize={'large'} onHide={this.closeJustificationModal}>
                <Modal.Header closeButton>
                  <Modal.Title id="hums-na-justification-modal">Justificativa para N/A</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="form-group">
                    <label>Informe a justificativa</label>
                    <textarea
                      className="form-control"
                      value={this.state.hums_justification_input}
                      onChange={this.handleNaJustificationChange}
                      rows={4}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button type="button" className="btn btn-default" onClick={this.closeJustificationModal}>
                    Cancelar
                  </button>
                  <button type="button" className="btn btn-primary" onClick={this.confirmNaJustification}>
                    <i className="fa fa-fw fa-save"></i> Confirmar
                  </button>
                </Modal.Footer>
              </Modal>
            </td>
            <td>
              <div className='row'>
                <div className='col-md-6'>
                  <div className="form-group">
                    <label>
                      <input
                        name="confirmed_unknown"
                        type="checkbox"
                        checked={this.state.confirmed_unknown}
                        onChange={this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_unknown')} 
                      />
                      &nbsp;
                      Unknown
                    </label>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="form-group">
                    <label>
                      <input
                        name="confirmed_na"
                        type="checkbox"
                        checked={this.state.confirmed_na}
                        onChange={this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_na')} 
                      />
                      &nbsp;
                      N/A
                    </label>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <div className="form-group">
                    <label>
                      <input
                        name="confirmed_false"
                        type="checkbox"
                        checked={this.state.confirmed_false}
                        onChange={this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_false')} 
                      />
                      &nbsp;
                      False
                    </label>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className="form-group">
                    <label>
                      <input
                        name="confirmed_real"
                        type="checkbox"
                        checked={this.state.confirmed_real}
                        onChange={this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_real')} 
                      />
                      &nbsp;
                      Real
                    </label>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <input type="text" name="hums_user_name" className="form-control text-center" value={this.state.hums_user_name} disabled />
            </td>
            <td>
              <input type="text" name="hums_approval_date" className="form-control text-center" value={this.state.hums_approval_date} disabled />
            </td>
          </tr>
        );
  }
}

export default AircraftLogbookHumsTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookHumsTab.js